













import {
  Component,
  Vue
} from 'vue-property-decorator';
import {
  UrgentNotificationDto
} from '@eurogast/hub-client-typescript';
import NotificationModalContent from '@/notifications/modal/NotificationModalContent.vue';
import MatomoCookieService from '@/services/matomo/MatomoCookieService';
import NotificationApiService from '@/services/notification/NotificationApiService';

@Component({
  components: {
    NotificationModalContent
  }
})
export default class NotificationModal extends Vue {

  private matomoCookieService = MatomoCookieService.singleton();
  private urgentNotificationApiService = NotificationApiService.singleton();

  public urgentNotification: UrgentNotificationDto | null = null;

  public closed = false;

  get isModalVisible(): boolean {
    return this.matomoCookieService.isCookieSet() &&
        this.urgentNotification &&
        this.urgentNotification.mostRecentUnread &&
        !this.closed;
  }


  public async mounted() {
    this.urgentNotification = await this.urgentNotificationApiService.fetchUrgentNotification();
  }

  public closeModalIfLinkWasClicked(event: Event) {
    const href = this.findHrefIfLinkWasClicked(event.target);
    if (href) {
      this.markNotificationAsReadBeforeNavigation(event, href);
    }
  }

  private findHrefIfLinkWasClicked(eventTarget: EventTarget): string | null {
    if (!(eventTarget instanceof HTMLElement)) {
      return null;
    }

    if (eventTarget.hasAttribute('href')) {
      return eventTarget.getAttribute('href');
    }

    const closestLinkElement = eventTarget.closest('a');

    if (closestLinkElement && closestLinkElement.href) {
      return closestLinkElement.href;
    }

    return null;
  }

  private async markNotificationAsReadBeforeNavigation(event: Event, href: string) {
    event.preventDefault();
    await this.close();
    window.location.href = href;
  }

  public async close() {
    await this.urgentNotificationApiService.markAsRead(this.urgentNotification);
    this.closed = true;
  }
}
